var general_rtlignore_default = {
  "alignLeft": "zD8nl",
  "textWrapNowrap": "pXO33",
  "alignRight": "_7JPgP",
  "alignCenter": "DttGU",
  "sizeFullWidth": "nbvZ5",
  "renderedInTable": "GiCzq",
  "sizeOriginal": "_2VUdA",
  "sizeContent": "iNRNG",
  "sizeSmall": "NJG3p",
  "sizeSmallCenter": "JPptI",
  "flex": "BpJYS"
};
export {
  general_rtlignore_default as default
};
//# sourceMappingURL=general.rtlignore-scss.js.map
